<template xmlns="http://www.w3.org/1999/html">
  <div class="main">

    <div 
      style="width: 100%;background-color:rgb(255, 244, 216);height: 100vh;display: flex;flex-direction: column;">
      <div style="position: absolute;top:10%;text-align: center;">
        <img src="/static/images/fuxiao/logo.png" width="35%" />
      </div>
      <div style="position: absolute;top:24%;text-align: center;width: 100%;">
        <div style="font-size: 24px;">防伪查询</div>
      </div>
      <div style="position: absolute;top:29%;text-align: center;width: 100%;">
        <div style="font-size: 20px;">Anti-counterfeiting inquiry</div>
      </div>

      <div style="position: absolute;top:45%;width: 100%;display: flex;align-items: center;flex-direction: column;">
        <div style="width: 90%;">
          <div style="font-weight: bold;font-size: 15px;">当前查询数码<br />
            防伪码：{{ this.antiCode }}<br /><br />
          </div>
          <div style="font-size: 14px;">{{ antiMessage }}
          </div>
        </div>
      </div>
    </div>



    <div v-show="isShow">
      <div id="fixedBg"></div>
      <p class="loading_p" id="loadP">
        <img src="/static/images/loadding.gif" />
      </p>
    </div>
  </div>
</template>

<style scoped src="../../assets/css/index.css"></style>

<style scoped src="../../assets/css/style.css"></style>


<style scoped>
.text-center {
  width: 100%;
  height: 300px;
  padding: 0px 30px 0px 30px;
  word-wrap: break-word;
  overflow-wrap: break-word;
}
</style>

<script>
import { getAntiResult, getInfoByCode } from '../../api/api'

export default {
  data() {
    return {
      isShow: false,
      antiCode: "",
      antiMessage:""
    }
  },
  methods: {
    getResult() {
      this.isShow = true
      const params = this.$route.query;
      const code = params.c;
      this.antiCode = code.substring(0, 16).replace(/(\w{4})(?=\w)/g, '$1 ');
      getAntiResult(code).then(res => {
        const data = res.data;
        this.isShow = false
        if (data == null || data.code == "500") {
          alert("防伪查询失败,请联系管理员");
        } else {
          this.antiMessage = data.message;
        }
      }).catch(err =>
        alert("查询异常，请联系管理员")
      )

    }
  },
  created: function () {
    this.getResult()
  }
}
</script>



// WEBPACK FOOTER //
// src/components/FuXiao/Index.vue